import * as React from "react";

function Billing(props) {
  return (
    <svg width={16} height={16} fill="none" {...props}>
      <path
        d="M4 7.333a.667.667 0 100 1.334.667.667 0 000-1.334zm8 0a.667.667 0 100 1.333.667.667 0 000-1.333zm1.333-4H2.667a2 2 0 00-2 2v5.334a2 2 0 002 2h10.666a2 2 0 002-2V5.333a2 2 0 00-2-2zM14 10.667a.667.667 0 01-.667.666H2.667A.667.667 0 012 10.667V5.333a.667.667 0 01.667-.666h10.666a.667.667 0 01.667.666v5.334zM8 6a2 2 0 100 4 2 2 0 000-4zm0 2.667a.667.667 0 110-1.334.667.667 0 010 1.334z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}

const BillingIcon = React.memo(Billing);
export default BillingIcon;
